<template>
  <div class="tile-box">
    <ul>
      <v-tooltip left v-for="item in items" v-bind:key="item.identifier">
        <template v-slot:activator="{ on }">
          <li id="mouseon" class="tile-sbox"  v-on="on">
            <div class="thumbnail"><router-link :to="'\/uuid\/' + item.identifier"><img v-bind:src="item.screen" alt="" /></router-link></div>
          </li>
        </template>
        <span>
          <h4><span v-for="c in item.subject" v-bind:key="c">{{ c }}&nbsp;</span></h4>
          <p>{{ item.description }}</p>
          <p>撮影日時：{{item.created | dateFormatter}}<br>撮影場所：{{item.spatial}}</p>
          <p>投稿者　：<span v-for="c in item.creator"  v-bind:key="c">{{ c }}</span><br>投稿日　：{{item.dateSubmitted| dateFormatter}}</p>
        </span>
      </v-tooltip>
      <template v-if="false">
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
        <li id="mouseon" class="tile-sbox" >
          <div class="thumbnail"><a href="det.html"><img src="../assets/logo.png" alt="" /></a></div>
        </li>
      </template>
    </ul>
  </div>

</template>
<script>
 export default {
     computed: {
         items: function(){
             return this.$store.getters.items;
         }
     },
     created(){
         this.$emit('itemmode','tile');
     },


 }

</script>
<style>
 /*---------------------------------

    tile

    ----------------------------------*/

 .tile-box {
     clear: both;
     margin: 20px -20px 0 0;
 }

 .tile-sbox {
     width: 250px;
     float: left;
     margin: 0 20px 20px 0;
 }

 .thumbnail{
     width: 250px;
     overflow: hidden;
     margin: 0;
     display: block;
 }

 .thumbnail a {
     display: block;
 }

 .thumbnail img{
     width: auto;
     height: 250px;
 }
 
 @media screen and (max-width:740px) {
 
 /*tile*/
.tile-sbox {
    width: 45%;
    float: left;
    margin: 0 5% 15px 0;
}

.thumbnail {
    position: relative;
    width: 100%;
	height: auto;
    background: #EEE;
}
.thumbnail::before {
    content:"";
    display: block;
    padding-top: 100%; /* 高さを幅の75%に固定 */
}
.thumbnail a {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
	display: block;
}

.thumbnail a img{
    position: absolute;
	 width: 100%;
    height: 100%;
}

}

</style>
